import { render, staticRenderFns } from "./report-payment.vue?vue&type=template&id=0bcbc083&"
import script from "./report-payment.vue?vue&type=script&lang=js&"
export * from "./report-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports